import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import ToggleButtonListItem from '../../../../../list-items/ToggleButtonListItem';
import { REFLECTION_TYPE, VISUALIZER_SHAPE } from '../../../Preview/PreviewDisplayConstants';

const reflectionTypeOptionsCircle = [
    { value: REFLECTION_TYPE.NONE, text: 'None' },
    { value: REFLECTION_TYPE.VERTICAL, text: 'Vertical' },
    { value: REFLECTION_TYPE.SLANTED, text: 'Across' },
    { value: REFLECTION_TYPE.THREE_WAY, text: '3-Way' },
    { value: REFLECTION_TYPE.FOUR_WAY, text: '4-Way' }
];

const reflectionTypeOptionsFlat = [
    { value: REFLECTION_TYPE.NONE, text: 'None' },
    { value: REFLECTION_TYPE.ONE_SIDE, text: '1 Side' },
    { value: REFLECTION_TYPE.TWO_SIDE, text: '2 Sides' },
    { value: REFLECTION_TYPE.COMBO, text: 'Combo' },
];

const VisualizerReflectionTypeListItem = (props) => {
    const { visualizerReflectionType, updateVisualizerReflectionType, visualizerShape } = props;
    const shapeIsCircle = visualizerShape === VISUALIZER_SHAPE.CIRCLE;

    const onTypeChange = (value) => updateVisualizerReflectionType(value);

    return (
        <ToggleButtonListItem
            text='Reflection'
            value={visualizerReflectionType}
            onChange={onTypeChange}
            options={shapeIsCircle ? reflectionTypeOptionsCircle : reflectionTypeOptionsFlat}
            lineBreak={shapeIsCircle}
        />
    );
};

const mapStateToProps = (state) => {
    const {
        reflectionType: visualizerReflectionType,
        shape: visualizerShape
    } = state.createPreview.present.videoSettings.visualizer;

    return {
        visualizerReflectionType,
        visualizerShape
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerReflectionType = (type) => dispatch(createActions.updateVisualizerReflectionType(type));
    return { updateVisualizerReflectionType }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerReflectionTypeListItem);